export default function AboutSection() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Cos&apos;&egrave; <strong>Itaobuy Spreadsheet</strong>?
          </h2>
        </div>
        <div className="bg-background-50 rounded-2xl border border-background-200 p-8 md:p-10">
          <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-4">
            <strong>Itaobuy Spreadsheet</strong> &egrave; una soluzione progettata per aiutare gli utenti a organizzare, analizzare e gestire informazioni attraverso un sistema semplice e intuitivo. Si tratta di uno strumento versatile che combina la potenza di un foglio di calcolo avanzato con la facilit&agrave; d&apos;uso che anche i principianti possono apprezzare.
          </p>
          <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
            Grazie alla sua struttura flessibile, <strong>Itaobuy Spreadsheet</strong> permette di migliorare la produttivit&agrave;, ridurre il lavoro manuale e avere una gestione pi&ugrave; ordinata dei dati. Che tu stia gestendo un inventario, monitorando vendite o organizzando informazioni personali, questo strumento ti offre tutto ci&ograve; di cui hai bisogno in un&apos;unica piattaforma accessibile.
          </p>
        </div>
      </div>
    </section>
  );
}